// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"7c91f9e4","498":"d8cf4803","513":"46d5597c","787":"c2677e38"}[chunkId] + ".chunk.js";
};